(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const body = document.body;
  const theme = window.HPTheme || {};

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const formatMoney = cents => {
    const amount = (Number(cents || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `Rs. ${amount}`;
  };

  // Header interactions
  const mobileMenu = $('[data-mobile-menu]');
  const overlay = $('[data-drawer-overlay]');
  const cartDrawer = $('[data-cart-drawer]');
  const megaMenu = $('[data-mega-menu]');
  const mobileSearchPanel = $('[data-mobile-search-panel]');

  function lockPage(lock) { body.classList.toggle('is-locked', lock); }
  function showOverlay(show) { if (!overlay) return; overlay.hidden = !show; }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open'); mobileMenu.setAttribute('aria-hidden', 'false');
    body.classList.add('mobile-menu-open');
    showOverlay(true); lockPage(true);
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden', 'true');
    body.classList.remove('mobile-menu-open');
    if (!cartDrawer?.classList.contains('is-open')) { showOverlay(false); lockPage(false); }
  }
  $('[data-open-mobile-menu]')?.addEventListener('click', openMobileMenu);
  $('[data-close-mobile-menu]')?.addEventListener('click', closeMobileMenu);

  $('[data-open-mega]')?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!megaMenu) return;
    megaMenu.hidden = !megaMenu.hidden;
  });
  document.addEventListener('click', e => {
    if (megaMenu && !megaMenu.hidden && !megaMenu.contains(e.target) && !e.target.closest('[data-open-mega]')) megaMenu.hidden = true;
  });

  $('[data-mobile-search-trigger]')?.addEventListener('click', () => {
    if (!mobileSearchPanel) return;
    mobileSearchPanel.hidden = !mobileSearchPanel.hidden;
    if (!mobileSearchPanel.hidden) setTimeout(() => $('input[type="search"]', mobileSearchPanel)?.focus(), 50);
  });

  // Live product search
  const liveForm = $('[data-live-search-form]');
  const liveInput = $('[data-live-search-input]');
  const liveResults = $('[data-live-search-results]');
  let searchTimer;
  liveInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = liveInput.value.trim();
    if (q.length < 2) { if (liveResults) liveResults.hidden = true; return; }
    searchTimer = setTimeout(async () => {
      try {
        const base = (theme.routes?.searchSuggest || '/search/suggest').replace(/\.json$/, '');
        const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        const data = await res.json();
        const products = data?.resources?.results?.products || [];
        if (!liveResults) return;
        if (!products.length) {
          liveResults.innerHTML = '<div class="live-search-empty">कोई product नहीं मिला</div>';
        } else {
          liveResults.innerHTML = products.map(p => `
            <a class="live-search-item" href="${escapeHtml(p.url)}">
              ${p.image ? `<img src="${escapeHtml(p.image)}" alt="">` : '<div></div>'}
              <strong>${escapeHtml(p.title)}</strong>
              <span>${formatMoney(p.price)}</span>
            </a>`).join('');
        }
        liveResults.hidden = false;
      } catch (_) { if (liveResults) liveResults.hidden = true; }
    }, 220);
  });
  document.addEventListener('click', e => {
    if (liveForm && liveResults && !liveForm.contains(e.target)) liveResults.hidden = true;
  });

  // Cart drawer
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false');
    showOverlay(true); lockPage(true);
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true');
    if (!mobileMenu?.classList.contains('is-open')) { showOverlay(false); lockPage(false); }
  }
  $$('[data-open-cart]').forEach(el => el.addEventListener('click', openCart));
  $('[data-close-cart]')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', () => { closeCart(); closeMobileMenu(); closeFilters(); });

  function renderCart(cart) {
    const count = cart.item_count || 0;
    $$('[data-header-cart-count]').forEach(el => { el.textContent = count; el.hidden = count === 0; });
    const drawerCount = $('[data-cart-count]'); if (drawerCount) drawerCount.textContent = `(${count})`;
    const total = $('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
    const footer = $('[data-cart-drawer-footer]'); if (footer) footer.hidden = count === 0;
    const wrap = $('[data-cart-drawer-body]'); if (!wrap) return;

    if (!count) {
      wrap.innerHTML = `<div class="empty-state"><div class="empty-state__icon">ॐ</div><h3>आपका कार्ट खाली है</h3><p>हमारे रत्न, रुद्राक्ष, ब्रेसलेट और आध्यात्मिक उत्पाद देखें।</p><a class="button" href="/collections/all">खरीदारी शुरू करें</a></div>`;
      return;
    }

    wrap.innerHTML = cart.items.map(item => `
      <div class="cart-line" data-line-key="${escapeHtml(item.key)}">
        <a class="cart-line__image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}">` : ''}</a>
        <div class="cart-line__info">
          <a href="${escapeHtml(item.url)}" class="cart-line__title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
          <div class="qty qty--small">
            <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="cart-line__remove" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0">हटाएँ</button>
      </div>`).join('');
  }

  async function fetchCart() {
    const res = await fetch(`${theme.routes?.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  async function addToCart(form) {
    const submit = $('[type="submit"]', form);
    const old = submit?.innerHTML;
    if (submit) { submit.disabled = true; submit.textContent = 'जोड़ रहे हैं…'; }
    try {
      const res = await fetch(`${theme.routes?.cartAdd || '/cart/add'}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error((await res.json())?.description || 'Product could not be added');
      const cart = await fetchCart(); renderCart(cart); openCart();
    } catch (err) {
      alert(err.message || 'कृपया दोबारा प्रयास करें।');
    } finally {
      if (submit) { submit.disabled = false; submit.innerHTML = old || 'कार्ट में जोड़ें'; }
    }
  }

  if (document.documentElement && window.HPTheme) {
    document.addEventListener('submit', e => {
      const form = e.target.closest('[data-ajax-cart-form]');
      if (!form) return;
      if (theme.ajaxCart !== false && window.innerWidth && theme && theme.routes) {
        e.preventDefault(); addToCart(form);
      }
    });
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    btn.disabled = true;
    try {
      const res = await fetch(`${theme.routes?.cartChange || '/cart/change'}.js`, {
        method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: btn.dataset.cartChange, quantity: Number(btn.dataset.quantity) })
      });
      const cart = await res.json(); renderCart(cart);
    } catch (_) { btn.disabled = false; }
  });

  // Product gallery and variants
  $$('[data-gallery-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
    const id = thumb.dataset.galleryThumb;
    $$('[data-gallery-thumb]').forEach(t => t.classList.toggle('is-active', t === thumb));
    $$('[data-gallery-slide]').forEach(s => s.classList.toggle('is-active', s.dataset.gallerySlide === id));
  }));

  const productSection = $('[data-product-section]');
  if (productSection) {
    const json = $('[data-product-variants]', productSection);
    let variants = [];
    try { variants = JSON.parse(json?.textContent || '[]'); } catch (_) {}
    const selects = $$('[data-option-index]', productSection);
    const variantInput = $('[data-variant-id]', productSection);
    const productSubmit = $('[data-product-submit]', productSection);
    const productSubmitLabel = $('[data-product-submit-label]', productSection);
    const buyNowButton = $('[data-product-buy-now]', productSection);
    const buyNowLabel = $('[data-buy-now-label]', productSection);
    const stickySubmit = $('[data-sticky-add]');
    const stickyPrice = $('[data-sticky-price]');

    const updateVariant = () => {
      const options = selects.map(s => s.value);
      const variant = variants.find(v => v.options.every((opt, i) => opt === options[i])) || variants[0];
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (productSubmit) productSubmit.disabled = !variant.available;
      if (productSubmitLabel) productSubmitLabel.textContent = variant.available ? 'कार्ट में जोड़ें' : 'उपलब्ध नहीं';
      if (buyNowButton) buyNowButton.disabled = !variant.available;
      if (buyNowLabel) buyNowLabel.textContent = variant.available ? 'अभी खरीदें' : 'उपलब्ध नहीं';
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const priceWrap = $('[data-product-price]');
      if (priceWrap) {
        const compare = Number(variant.compare_at_price || 0), price = Number(variant.price || 0);
        const save = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
        priceWrap.innerHTML = `<div class="price"><span class="price__current">${formatMoney(price)}</span>${compare > price ? `<s class="price__compare">${formatMoney(compare)}</s><span class="price__save">${save}% OFF</span>` : ''}</div>`;
      }
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    selects.forEach(s => s.addEventListener('change', updateVariant));

    $('[data-qty-minus]', productSection)?.addEventListener('click', () => { const i = $('[data-qty-input]', productSection); if (i) i.value = Math.max(1, Number(i.value || 1) - 1); });
    $('[data-qty-plus]', productSection)?.addEventListener('click', () => { const i = $('[data-qty-input]', productSection); if (i) i.value = Number(i.value || 1) + 1; });
    stickySubmit?.addEventListener('click', () => $('#product-form')?.requestSubmit());

    buyNowButton?.addEventListener('click', async () => {
      const form = $('#product-form');
      if (!form || buyNowButton.disabled) return;
      const oldLabel = buyNowLabel?.textContent || 'अभी खरीदें';
      buyNowButton.disabled = true;
      buyNowButton.classList.add('is-loading');
      if (buyNowLabel) buyNowLabel.textContent = 'Checkout तैयार हो रहा है…';
      try {
        const response = await fetch(`${theme.routes?.cartAdd || '/cart/add'}.js`, {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
        });
        if (!response.ok) {
          let message = 'Checkout शुरू नहीं हो पाया।';
          try { message = (await response.json())?.description || message; } catch (_) {}
          throw new Error(message);
        }
        window.location.assign('/checkout');
      } catch (error) {
        alert(error.message || 'कृपया दोबारा प्रयास करें।');
        buyNowButton.disabled = false;
        buyNowButton.classList.remove('is-loading');
        if (buyNowLabel) buyNowLabel.textContent = oldLabel;
      }
    });

    updateVariant();
  }

  // Product recommendations
  const recommendations = $('[data-product-recommendations]');
  if (recommendations && recommendations.dataset.url && !recommendations.innerText.trim()) {
    fetch(recommendations.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-product-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) recommendations.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  } else if (recommendations && recommendations.dataset.url) {
    fetch(recommendations.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-product-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) recommendations.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  }

  // Collection filters / sorting
  const filters = $('[data-collection-filters]');
  function openFilters(){ if (!filters) return; filters.classList.add('is-open'); showOverlay(true); lockPage(true); }
  function closeFilters(){ if (!filters) return; filters.classList.remove('is-open'); if (!cartDrawer?.classList.contains('is-open') && !mobileMenu?.classList.contains('is-open')) { showOverlay(false); lockPage(false); } }
  $('[data-toggle-filters]')?.addEventListener('click', openFilters);
  $('[data-close-filters]')?.addEventListener('click', closeFilters);
  $('[data-sort-select]')?.addEventListener('change', e => { const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page'); location.href = url.toString(); });

  // Cart page quantity controls
  document.addEventListener('click', e => {
    const minus = e.target.closest('[data-page-qty-minus]');
    const plus = e.target.closest('[data-page-qty-plus]');
    if (!minus && !plus) return;
    const qty = e.target.closest('.qty'); const input = $('input', qty); if (!input) return;
    input.value = Math.max(0, Number(input.value || 0) + (plus ? 1 : -1));
  });

  // Escape closes overlays
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeCart(); closeMobileMenu(); closeFilters();
    if (megaMenu) megaMenu.hidden = true;
    if (mobileSearchPanel) mobileSearchPanel.hidden = true;
  });
})();

/* HinduPanchang Store v3 enhancements */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const formatMoney = cents => `Rs. ${(Number(cents || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  // Compact category rails
  $$('[data-category-section]').forEach(section => {
    const rail = $('[data-scroll-rail]', section);
    if (!rail) return;
    $$('[data-rail-scroll]', section).forEach(button => button.addEventListener('click', () => {
      const direction = button.dataset.railScroll === 'prev' ? -1 : 1;
      rail.scrollBy({ left: direction * Math.max(320, rail.clientWidth * .78), behavior: 'smooth' });
    }));
  });

  // Subtle 3D hero parallax. CSS animations remain active without pointer input.
  const hero = $('[data-hero-parallax]');
  const heroStage = hero && $('[data-hero-stage]', hero);
  if (heroStage && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let raf = 0;
    const reset = () => $$('[data-depth]', heroStage).forEach(el => {
      el.style.setProperty('--parallax-x', '0px');
      el.style.setProperty('--parallax-y', '0px');
    });
    heroStage.addEventListener('pointermove', event => {
      if (window.innerWidth < 760) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const rect = heroStage.getBoundingClientRect();
        const nx = ((event.clientX - rect.left) / rect.width - .5) * 2;
        const ny = ((event.clientY - rect.top) / rect.height - .5) * 2;
        $$('[data-depth]', heroStage).forEach(el => {
          const depth = Number(el.dataset.depth || .3);
          el.style.setProperty('--parallax-x', `${(nx * 16 * depth).toFixed(2)}px`);
          el.style.setProperty('--parallax-y', `${(ny * 12 * depth).toFixed(2)}px`);
        });
      });
    });
    heroStage.addEventListener('pointerleave', reset);
  }

  // Rolling product-count proof: compact, GIF-like motion without an image asset.
  const heroCounter = $('[data-hero-product-counter]');
  if (heroCounter) {
    const min = Number(heroCounter.dataset.min || 450);
    const max = Math.max(min, Number(heroCounter.dataset.max || 500));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || max === min) {
      heroCounter.textContent = `${max}+`;
    } else {
      let value = min;
      let holdTimer = 0;
      const tick = () => {
        if (holdTimer > 0) { holdTimer -= 1; return; }
        value += 1;
        if (value > max) { value = min; heroCounter.classList.remove('is-at-max'); }
        heroCounter.textContent = `${value}+`;
        if (value === max) { heroCounter.classList.add('is-at-max'); holdTimer = 18; }
      };
      window.setInterval(tick, 90);
    }
  }

  // Local wishlist — zero app dependency.
  const wishlistKey = 'hpWishlistV1';
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (_) { return []; }
  };
  const paintWishlist = () => {
    const list = new Set(readWishlist());
    $$('[data-wishlist-toggle]').forEach(button => {
      const active = list.has(button.dataset.wishlistToggle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (button.classList.contains('product-card__wishlist')) button.textContent = active ? '♥' : '♡';
      if (button.classList.contains('product-page-wishlist')) {
        const text = $('span', button);
        if (text) text.textContent = active ? 'Saved' : 'Wishlist';
      }
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlistToggle;
    const list = new Set(readWishlist());
    list.has(handle) ? list.delete(handle) : list.add(handle);
    localStorage.setItem(wishlistKey, JSON.stringify(Array.from(list)));
    paintWishlist();
  });
  paintWishlist();

  // Homepage catalog browser: append products progressively instead of forcing a huge first load.
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-load-more-products]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    const original = button.innerHTML;
    button.textContent = 'Products load हो रहे हैं…';
    try {
      const section = button.closest('[data-product-browser]');
      const grid = $('[data-product-browser-grid]', section);
      const url = new URL(button.href, location.origin);
      url.searchParams.set('section_id', button.dataset.sectionId || section.dataset.sectionId);
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Load failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshGrid = $('[data-product-browser-grid]', doc);
      if (freshGrid && grid) Array.from(freshGrid.children).forEach(card => grid.appendChild(card));
      const freshButton = $('[data-load-more-products]', doc);
      const freshStatus = $('[data-browser-status]', doc);
      const status = $('[data-browser-status]', section);
      if (status && freshStatus) status.textContent = freshStatus.textContent;
      if (freshButton) {
        button.href = freshButton.getAttribute('href');
        button.innerHTML = original;
        button.classList.remove('is-loading');
      } else {
        button.replaceWith(Object.assign(document.createElement('span'), { className: 'product-browser__complete', textContent: 'आपने सभी products देख लिए ✓' }));
      }
      paintWishlist();
    } catch (_) {
      button.innerHTML = original;
      button.classList.remove('is-loading');
      location.href = button.href;
    }
  });

  // Collection pages: progressive load-more with pagination fallback when JS is disabled.
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-collection-load-more]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    const original = button.innerHTML;
    button.textContent = 'और products load हो रहे हैं…';
    const results = button.closest('.collection-results');
    try {
      const response = await fetch(button.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Load failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshGrid = $('[data-collection-product-grid]', doc);
      const grid = $('[data-collection-product-grid]', results);
      if (freshGrid && grid) Array.from(freshGrid.children).forEach(card => grid.appendChild(card));
      const freshButton = $('[data-collection-load-more]', doc);
      const freshStatus = $('[data-collection-status]', doc);
      const status = $('[data-collection-status]', results);
      if (status && freshStatus) status.textContent = freshStatus.textContent;
      if (freshButton) {
        button.href = freshButton.getAttribute('href');
        button.innerHTML = original;
        button.classList.remove('is-loading');
      } else {
        button.remove();
        if (status) status.textContent += ' • सभी products loaded ✓';
      }
      paintWishlist();
    } catch (_) {
      button.innerHTML = original;
      button.classList.remove('is-loading');
      location.href = button.href;
    }
  });

  // Product image lightbox
  const lightbox = $('[data-product-lightbox]');
  const lightboxImage = lightbox && $('[data-lightbox-image]', lightbox);
  const openLightbox = () => {
    const active = $('.product-gallery__slide.is-active[data-gallery-image]');
    if (!lightbox || !lightboxImage || !active) return;
    lightboxImage.src = active.dataset.galleryImage;
    lightbox.hidden = false;
    document.body.classList.add('is-locked');
  };
  $('[data-product-zoom]')?.addEventListener('click', openLightbox);
  $('.product-gallery__main')?.addEventListener('dblclick', openLightbox);
  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('is-locked');
  };
  $('[data-close-product-lightbox]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox(); });

  // Product sticky buy bar appears only after the main purchase card leaves view.
  const productForm = $('#product-form');
  const sticky = $('[data-product-sticky]');
  if (productForm && sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      const visible = entries[0]?.isIntersecting;
      sticky.classList.toggle('is-visible', !visible);
    }, { threshold: .15 });
    observer.observe(productForm);
  } else if (sticky) {
    sticky.classList.add('is-visible');
  }

  // Keep savings label synced after variant changes.
  const productSection = $('[data-product-section]');
  if (productSection) {
    const variantsScript = $('[data-product-variants]', productSection);
    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (_) {}
    const updateSaving = () => {
      const selects = $$('[data-option-index]', productSection);
      const options = selects.map(select => select.value);
      const variant = variants.find(v => v.options.every((option, index) => option === options[index])) || variants[0];
      if (!variant) return;
      let saving = $('[data-product-saving]', productSection);
      const amount = Number(variant.compare_at_price || 0) - Number(variant.price || 0);
      if (amount > 0) {
        if (!saving) {
          saving = document.createElement('div');
          saving.className = 'product-saving';
          saving.dataset.productSaving = '';
          $('[data-product-price]', productSection)?.insertAdjacentElement('afterend', saving);
        }
        saving.textContent = `आज की कीमत पर ${formatMoney(amount)} की बचत`;
      } else if (saving) saving.remove();
    };
    $$('[data-option-index]', productSection).forEach(select => select.addEventListener('change', () => setTimeout(updateSaving, 0)));

    // Recently viewed storage for future merchandising integrations.
    const currentData = $('[data-current-product]', productSection);
    try {
      const current = JSON.parse(currentData?.textContent || '{}');
      if (current.handle) {
        const old = JSON.parse(localStorage.getItem('hpRecentlyViewedV1') || '[]').filter(item => item.handle !== current.handle);
        localStorage.setItem('hpRecentlyViewedV1', JSON.stringify([current, ...old].slice(0, 8)));
      }
    } catch (_) {}
  }

  // Hindi ↔ English convenience translation.
  const languageButtons = $$('[data-language-toggle]');
  if (languageButtons.length) {
    languageButtons.forEach(button => button.classList.add('notranslate'));
    const host = document.getElementById('google_translate_element');
    const languageStorageKey = 'hpStoreLanguage';
    const isEnglish = () => localStorage.getItem(languageStorageKey) === 'en' || /googtrans=\/hi\/en/.test(document.cookie);
    const setTranslateCookie = value => {
      const maxAge = 60 * 60 * 24 * 365;
      document.cookie = `googtrans=${value};path=/;max-age=${maxAge};SameSite=Lax`;
      try { document.cookie = `googtrans=${value};path=/;domain=.${location.hostname};max-age=${maxAge};SameSite=Lax`; } catch (_) {}
    };
    const clearTranslateCookie = () => {
      document.cookie = 'googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      try { document.cookie = `googtrans=;path=/;domain=.${location.hostname};expires=Thu, 01 Jan 1970 00:00:00 GMT`; } catch (_) {}
    };
    const paintLanguage = () => {
      const english = isEnglish();
      $$('[data-language-label]').forEach(el => el.textContent = english ? 'हिं' : 'EN');
      $$('[data-language-long-label]').forEach(el => el.textContent = english ? 'हिन्दी में देखें' : 'English में देखें');
    };
    paintLanguage();
    languageButtons.forEach(button => button.addEventListener('click', () => {
      if (isEnglish()) {
        localStorage.setItem(languageStorageKey, 'hi');
        clearTranslateCookie();
      } else {
        localStorage.setItem(languageStorageKey, 'en');
        setTranslateCookie('/hi/en');
      }
      location.reload();
    }));

    if (isEnglish()) setTranslateCookie('/hi/en');
    if (host && !document.querySelector('script[data-hp-google-translate]')) {
      window.googleTranslateElementInit = function () {
        if (!window.google?.translate?.TranslateElement) return;
        new window.google.translate.TranslateElement({ pageLanguage: 'hi', includedLanguages: 'hi,en', autoDisplay: false }, 'google_translate_element');
        paintLanguage();
      };
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.dataset.hpGoogleTranslate = 'true';
      document.head.appendChild(script);
    }
  }
})();
